import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssignEvaluatorComponent } from './assign-evaluator/assign-evaluator.component';
import { AssignSingleEvaluatorComponent } from './assign-single-evaluator/assign-single-evaluator.component';
import { AssessmentsEvaluatorComponent } from './assessments-evaluator/assessments-evaluator.component';
import { AssessComponent } from './assess/assess.component';
import { EvaluateRequestComponent } from './evaluate-request/evaluate-request.component';
import { SavedEvaluationComponent } from './saved-evaluation/saved-evaluation.component';

const routes: Routes = [
  { path: 'evaluaciones', component: AssessmentsEvaluatorComponent},
  { path: 'evaluaciones/asignar-evaluadores', component: AssignEvaluatorComponent},
  { path: 'evaluaciones/asignar-evaluador-materias', component: AssignSingleEvaluatorComponent},
  { path: 'evaluaciones/evaluar', component: AssessComponent},
  { path: 'evaluaciones/evaluar/materias', component: EvaluateRequestComponent},
  { path: 'evaluaciones/evaluar/materias/confirmacion', component: SavedEvaluationComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssessmentsRoutingModule { }
